var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5722",
    d: "M6 6H22V22H6z",
    transform: "rotate(-180 14 14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M26 6H42V22H26z",
    transform: "rotate(-180 34 14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M26 26H42V42H26z",
    transform: "rotate(-180 34 34)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M6 26H22V42H6z",
    transform: "rotate(-180 14 34)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/Microsoft.017bad9596f2c0b9a86af8325b31c8b9.svg";
export { ForwardRef as ReactComponent };